import axios from 'axios';
import Qs from "qs";
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import router from '../router/index';

import { Message } from 'element-ui'

axios.interceptors.request.use(config => {
  NProgress.start();
  return config;
});
let isShow = 0;
// 拦截响应。在这里隐藏进度条
axios.interceptors.response.use(response => {
  NProgress.done();
  return response;
}, (error) => {
  if (error.response.status == 401) {//登录时间过期
    sessionStorage.removeItem("token");
    if(isShow == 0){
      Message.error('登录过期,请重新登录');
      isShow=1;
    }
    router.replace("/login");//replace会把当前页面替换 并不会产生历史记录 
  }
  return Promise.reject(error);
});

/**
 *  该接口负责处理此项目所有的get请求
 * @param {*} url 代表接口位置
 * @param {*} params params代表参数(可选)
 * @returns promise对象
 * 
 */
function getRequest(url, params) {
  return new Promise((resolve) => {
    axios.get(url, { params }).then(res => {
      resolve(res);
    })
  })
}
/**
 * 该接口负责处理此项目所有的post
 * @param {*} url 代表接口位置
 * @param {Object} params params代表参数
 * @returns 
 */
function postRequest(url, params) {
  // let usp = new URLSearchParams(params)
  return new Promise(resolve => {
    axios({
      // headers: {
      //    'Content-Type': 'application/x-www-form-urlencoded'
      // },
      method: 'post',
      url,
      // data: Qs.stringify(params) //qs.stringify()将对象 序列化成URL的形式，以&进行拼接
      data:params,
    }).then(res => {
      resolve(res);
    })
  })
}

export {
  getRequest,
  postRequest
}